import { useTranslation } from "next-i18next";
import SortIcon from "../icons/SortIcon";
import CloseIcon from "../icons/CloseIcon";
import { sortKeys } from "@/constants/Category";
import { useRef } from "react";
import useOnClickOutside from "@/hooks/useOnClickOutside";
// import { useState } from "react";

const SortBy = ({ handleSorting, allSortingKeys, setSortName, setShowType }) => {
  const { t } = useTranslation("category");
  // const [sortName, setSortName] = useState('Recommended')
  const ref = useRef();
  useOnClickOutside([ref], () => setShowType(null));
  console.log(sortKeys);
  return (
    <div ref={ref} className="absolute bottom-0 left-0 w-screen bg-white">
      <div className="flex items-center justify-between px-2 py-3 border-b">
        <div className="flex items-center gap-2">
          <SortIcon className="size-5" />
          <span className="font-bold max-sm:text-xs">{t("Sort By")}</span>
        </div>
        <button onClick={() => setShowType(null)}>
          <CloseIcon className="size-3 max-sm:size-2.5" />
        </button>
      </div>
      <ul className="p-2 border-b">
        {sortKeys?.map((item, key) => (
          <li
            key={key}
            onClick={() => {
              handleSorting({ keys: item?.key });
              setSortName(item?.label);
              setShowType(null);
            }}
            className={`${
              sortKeys?.length - 1 != key ? "mb-2.5" : null
            } p-2 cursor-pointer max-sm:text-xs ${allSortingKeys==item?.key ? "bg-warning" : "bg-white"}`}
          >
            {t(item?.label)}
          </li>
        ))}
      </ul>
      {/* <div className="grid grid-cols-2 p-2 max-sm:text-xs gap-2">
        <button
          className="bg-primary px-1 py-1.5 sm:p-2 text-white rounded-md"
          onClick={() => setShowType(null)}
        >
          {t("Show Result")}
        </button>
        <button
          className={`px-1 py-2 text-white rounded-md bg-primary sm:p-2`}
          onClick={() => handleSorting({ keys: "sortBy=position&sortDir=ASC" })}
        >
          {t("Reset sorting")}
        </button>
      </div> */}
    </div>
  );
};

export default SortBy;
